import { Button, Kind, Size } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'
import Checkmark from 'components/Icons/Checkmark'
import Sync from 'components/Icons/Sync'
import palette from 'constants/palette'
import React from 'react'

export interface SyncRowLabels {
  /** Fully resolved "Synced from %{provider} %{time}" copy. */
  synced: string
  /** Fully resolved "Not yet synced from %{provider}" copy. */
  never: string
  auto: string
  syncNow: string
}

type Props = {
  onSyncNow: () => void
  syncedAt?: string | null
  isSyncing?: boolean
  /** Pre-translated, namespace-owned strings (the component is i18n-agnostic). */
  labels: SyncRowLabels
}

const SyncRow = ({ onSyncNow, syncedAt, isSyncing = false, labels }: Props) => {
  const statusText = syncedAt ? labels.synced : labels.never

  return (
    <div className="d-flex align-items-center justify-content-end mb-s">
      {syncedAt && (
        <span className="mr-xs d-flex" aria-hidden="true">
          <Checkmark />
        </span>
      )}
      <Text.BodyText4 color="grey70" className="mr-s">
        {statusText}
      </Text.BodyText4>
      <Text.BodyText5 color="grey50" className="mr-m">
        {labels.auto}
      </Text.BodyText5>
      <Button
        kind={Kind.SECONDARY}
        size={Size.SMALL}
        onClick={onSyncNow}
        isLoading={isSyncing}
      >
        <span className="d-flex align-items-center">
          <span aria-hidden="true" className="d-flex">
            <Sync pathColor={palette.belizeHole} className="mr-xs" />
          </span>
          {labels.syncNow}
        </span>
      </Button>
    </div>
  )
}

export default SyncRow
